export enum PublisherClassType {

  PROMOTIONAL_TYPE = 'promotionalType',
  TAG = 'tag',

}

export const newPublisherTag = (
  id: number,
  name: string,
): PublisherTag =>
  ({
    id,
    type: PublisherClassType.TAG,
    name,
  });

export const newPromotionalType = (
  id: number,
  name: string,
): PromotionalType =>
  ({
    id,
    type: PublisherClassType.PROMOTIONAL_TYPE,
    name,
  });

export const isTag = (publisherClass: PublisherClassIdentity) => publisherClass.type === PublisherClassType.TAG;
export const isPromotionalType = (publisherClass: PublisherClassIdentity) => publisherClass.type === PublisherClassType.PROMOTIONAL_TYPE;

export interface PublisherClassIdentity {

  readonly id: number;
  readonly type: PublisherClassType;

}

export interface NamedPublisherClass extends PublisherClassIdentity {

  readonly name: string;

}

export interface PublisherTag extends NamedPublisherClass {

  readonly type: PublisherClassType.TAG;

}

export interface PromotionalType extends NamedPublisherClass {

  readonly type: PublisherClassType.PROMOTIONAL_TYPE;

}

export interface PromotionalTypeGroup {

  readonly name: string;
  readonly types: PromotionalType[];

}

export interface PublisherTagsAndPromotionalTypes {

  readonly publisherTags: PublisherTag[];
  readonly promotionalTypes: PromotionalTypeGroup[];

}

export const EMPTY_PUBLISHER_TAGS_AND_PROMOTIONAL_TYPES: PublisherTagsAndPromotionalTypes = {

  publisherTags: [],
  promotionalTypes: [],

};
